<template>
  <a class="text-uppercase font-weight-bold" @click="showDialog = true">
    {{ $t('pd-text-0') }}
    <v-dialog v-model="showDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth"
              content-class="full-screen-dialog">
      <v-card>
        <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
          <v-toolbar-title>{{ $t('pd-text-1') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn light icon @click="showDialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
        <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
          <v-row justify="end">
            <v-col class="shrink">
              <v-btn color="color-grey" depressed right text small @click="showDialog = false">
                <v-icon class="mr-3">fa-times</v-icon>
                <span>{{ $t('close') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="pt-0 pb-16" fluid>
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
                <v-col class="text-center">
                  <h2 class="mt-0 text-h2">{{ $t('pd-text-1') }}</h2>
                  <p class="mb-0">{{ $t('pd-text-2') }}</p>
                  <p>{{ $t('pd-text-2-1') }}<a @click="goToPrivacy">{{ $t('pd-text-2-2') }}</a>{{ $t('pd-text-2-3') }}</p>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="8" md="9">
                  <p class="ok-title big alt bold">{{ $t('pd-text-3') }}</p>
                  <p>{{ $t('pd-text-4') }}</p>
                </v-col>
                <v-col cols="4" md="3">
                  <v-switch :label="anAllowed ? $t('pd-text-9') : $t('pd-text-10')" disabled v-model="anAllowed" />
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="8" md="9">
                  <p class="ok-title big alt bold">{{ $t('pd-text-7') }}</p>
                  <p>{{ $t('pd-text-8') }}</p>
                </v-col>
                <v-col cols="4" md="3">
                  <v-switch :label="coAllowed ? $t('pd-text-9') : $t('pd-text-10')" v-model="coAllowed" />
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="8" md="9">
                  <p class="ok-title big alt bold">{{ $t('pd-text-5') }}</p>
                  <p>{{ $t('pd-text-6') }}</p>
                </v-col>
                <v-col cols="4" md="3">
                  <v-switch :label="trAllowed ? $t('pd-text-9') : $t('pd-text-10')" v-model="trAllowed" />
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-3">
                  <v-btn dark large block tile color="primary" @click="saveConsentData">
                    {{ $t('pd-text-11') }}
                  </v-btn>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </a>
</template>

<script>
  export default {
    data: function () {
      return {
        showDialog: false,
        coAllowed: false,
        trAllowed: false,
        anAllowed: true
      }
    },
    mounted() {
      this.trAllowed = this.$store.getters.trackingAllowed
      this.coAllowed = this.$store.getters.cookiesAllowed
    },
    computed: {
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false, // this.$vuetify.breakpoint.smAndDown,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1000px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      }
    },
    methods: {
      saveConsentData() {
        this.$store.commit('trackingAllowed', this.trAllowed)
        this.$store.commit('cookiesAllowed', this.coAllowed)
        this.$store.commit('privacyConsentAnswered', true)
        this.showDialog = false
      },
      goToPrivacy() {
        this.$router.push('/privacy')
        this.showDialog = false
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "pd-text-0": "Muuta asetuksia",
  "pd-text-1": "Hallinnoi asetuksia",
  "pd-text-2": "Voit hallinnoida tietojen keräyksen asetuksia alla olevilla valinnoilla.",
  "pd-text-2-1": "Kerromme aiheesta tarkemmin ",
  "pd-text-2-2": "Tietoa evästeistä",
  "pd-text-2-3": " -sivulla.",
  "pd-text-3": "Välttämättömät evästeet",
  "pd-text-4": "Nämä evästeet ovat tarpeellisia sivuston toiminnan kannalta, eikä niitä voi poistaa käytöstä.",
  "pd-text-5": "Kohdennettu seuranta",
  "pd-text-6": "Kohdennetun seurannan avulla voimme seurata yksittäisten käyttäjien tekemiä toimia, ja käyttää tietoja tuotekehityksessämme. Emme luovuta tietoja kolmansille osapuolille.",
  "pd-text-7": "Tilastolliset evästeet",
  "pd-text-8": "Näiden avulla voimme parantaa palvelusta kerätyn analytiikan tarkkuutta, ja esimerkiksi tunnistaa kävijöitä useiden vierailujen välillä.",
  "pd-text-9": "Sallittu",
  "pd-text-10": "Ei sallittu",
  "pd-text-11": "Tallenna asetukset"
  },
  "se": {
  "pd-text-0": "Ändra inställningar",
  "pd-text-1": "Hantera inställningar",
  "pd-text-2": "Du kan göra ändringar i vilka uppgifter som sparas genom att ändra inställningarna här nedanför.",
  "pd-text-2-1": "Mer information hittas på ",
  "pd-text-2-2": "Om webbkakor",
  "pd-text-2-3": " -sidan.",
  "pd-text-3": "Nödvändiga webbkakor",
  "pd-text-4": "Dessa kakor är nödvändiga för att webbplatsen ska fungera och kan därför inte tas ur bruk.",
  "pd-text-5": "Riktade webbkakor",
  "pd-text-6": "Med riktade webbkakor kan vi samla information om hur enskilda besökare använder vår tjänst och använda informationen för att förbättra våra produkter. Vi överlåter inte uppgifterna till någon tjedje part.",
  "pd-text-7": "Webbkakor för analys",
  "pd-text-8": "Dessa används för att förbättra exaktheten i den analytiska datan som samlats in, till exempel för att identifiera besökare som besöker sidan flera gånger",
  "pd-text-9": "Aktiverad",
  "pd-text-10": "Inte aktiverad",
  "pd-text-11": "Spara inställningarna"
  },
  "en": {
  "pd-text-0": "Manage settings",
  "pd-text-1": "Manage Settings",
  "pd-text-2": "You can change what data is collected by adjusting the settings below.",
  "pd-text-2-1": "For more infomation see ",
  "pd-text-2-2": "About cookies",
  "pd-text-2-3": " page.",
  "pd-text-3": "Necessary cookies",
  "pd-text-4": "These cookies are necessary for providing the service and cannot be disabled.",
  "pd-text-5": "Targeted analytics",
  "pd-text-6": "With this information we can see how our individual customers use our services and use this information to improve our products. We do not share this data with third parties.",
  "pd-text-7": "Statistical cookies",
  "pd-text-8": "These are used to improve the accuracy of analytics data, for example to identify returning visitors.",
  "pd-text-9": "Enabled",
  "pd-text-10": "Disabled",
  "pd-text-11": "Save settings"
  }
  }
</i18n>
